/**
 * Build a single schema.org `@graph` JSON string from page nodes.
 * Empty / nullish nodes are dropped so callers can push optional entities freely.
 */
export function serializeSchemaGraph(
  nodes: ReadonlyArray<Record<string, unknown> | null | undefined>,
): string {
  const graph = nodes.filter(
    (node): node is Record<string, unknown> => node != null && Object.keys(node).length > 0,
  );
  if (!graph.length) {
    return "";
  }
  return JSON.stringify({
    "@context": "https://schema.org",
    "@graph": graph,
  });
}
